import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../assets/jss/customStyle";
import $ from "jquery";
import moment from "moment";
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import axios from "axios";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { TextField, Checkbox, InputBase, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import API from "../../../../_helpers/endpointService";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { filedeletedis, deleteiddis } from "../../../../actions/DispositionAction";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Autocomplete from "react-autocomplete"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

class EditDROHM extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            value: 0,
            isView: false,
            ProjectId: 0,
            Docs: [],
            filename: "",
            awsname: "",
            cancel: false,
            DelIndex: 0,
            addData: {
                ManifestNo: '',
                Date: '',
                Id: 0,
                ProjectId: 0,
                QuantityIHM: '',
                QuantityGPCB: '',
                Remarks: '',
                Material: '',
                DiposedMTQuantity: '',
                Comments: '',
                ModifiedBy: ""
            },
            Error: {
                DateError: false,
                DiposedMTQuantityError: false,
            },
        }
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        if (window.innerWidth < 412) {
            this.setState({
                isMore: true
            })
        }
        else {
            this.setState({
                isMore: false
            })
        }

        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
    };
    resize1 = () => {
        $("#DIS1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disposition1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Disposition").removeClass("d-none");
        $("#Disposition").addClass("d-block");
        $("#DROHML").addClass("active-color");
        $("#DROHMT").addClass("fw-bolder");
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.Id = parseInt(localStorage.getItem("DISEditId"))
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.geteditdisdocinfo(this.state.addData.Id)
        dispatch(getlookupdocinfo("Hazardous"))
        this.geteditdisdocinfo(this.state.addData.Id)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#DIS1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Disposition1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Disposition").addClass("d-none");
        $("#Disposition").removeClass("d-block");
        $("#DROHML").removeClass("active-color");
        $("#DROHMT").removeClass("fw-bolder");
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (newValue === 1) {
            this.gethistorylogdisdocinfo(this.state.ProjectId)
        }
        else{
            // this.geteditdisdocinfo(this.state.addData.Id)
        }
    };
    gethistorylogdisdocinfo = (id) => {
        let apiUrl = API.HISTORY_LOG + id + '?name=Disposition'
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "HISTORY_LOG", data: response.data });
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    geteditdisdocinfo = (id) => {
        let apiUrl = API.DIS_LISTVIEW + '/' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.addData.Material = response.data.Material;
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Date = response.data.Date;
                    this.state.addData.QuantityIHM = response.data.QuantityIHM;
                    this.state.addData.QuantityGPCB = response.data.QuantityGPCB;
                    this.state.addData.Remarks = response.data.Remarks;
                    this.state.addData.ManifestNo = response.data.ManifestNo;
                    this.state.addData.DiposedMTQuantity = response.data.DiposedMTQuantity;
                    this.state.addData.Comments = response.data.Comments;
                    if (response.data?.Attachment != undefined) {
                        this.state.Docs = {
                            FileName: response.data.Attachment.FileName,
                            ObjectKey: response.data.Attachment.ObjectKey,
                            AwsFolderName: response.data.Attachment.AwsFolderName,
                            AwsUniqueFileName: response.data.Attachment.AwsUniqueFileName,
                            FileExtention: response.data.Attachment.FileExtention,
                            FileUrl: response.data.Attachment.FileUrl,
                            FileSize: response.data.Attachment.FileSize,
                            check: false,
                        }
                        this.setState({})
                    }

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    }
    EditCancel1 = () => {
        if (this.state.value === 1) {
            this.setState({
                value: 0
            })
            this.geteditdisdocinfo(this.state.addData.Id)
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate(`/dispositionrecordsofhazardousmaterials`)
            }
        }
    }
    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dispositionrecordsofhazardousmaterials")
    };
    ViewCancel = () => {
        this.props.navigate("/dispositionrecordsofhazardousmaterials")
    };
    DeleteItemID = () => {

        this.state.addData.Id = parseInt(localStorage.getItem("DISEditId"))
        this.deleteiddis(this.state.addData.Id, this.state.UserRole)

    }
    deleteiddis = (id, modify) => {

        let apiUrl = API.DIS_LISTVIEW + '/' + id + '?modify=' + modify;

        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/dispositionrecordsofhazardousmaterials")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });

    };
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };
    UploadFile = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs = upload
            this.setState({})
        })
    };
    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    DeleteItem = () => {

        let tempData = {};
        if (this.state.DelIndex == 0) {
            if (this.state.Docs.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeletedis(this.state.addData.Id, this.state.awsname))
                this.state.cancel = true
            }
        }
        this.state.Docs = {};
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    handleInputChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
        else if (node == "Remarks") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[node] = e.target.value;
            this.setState({});
        }
    };
    handleNumberChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value === '') {
            this.state.addData[node] = ''
            this.setState({});
        }
        else {
            this.state.addData[node] = parseFloat(e.target.value)
            this.setState({});

        }
    }
    EditSave = () => {
        if (this.state.addData.Date == "") {
            this.state.Error.DateError = true;
            this.setState({})
        }
        else {
            this.state.Error.DateError = false;
            this.setState({})
        }
        if (this.state.addData.DiposedMTQuantity === "") {
            this.state.Error.DiposedMTQuantityError = true;
            this.setState({})
        }
        else {
            this.state.Error.DiposedMTQuantityError = false;
            this.setState({})
        }

        if (this.state.addData.Date !== '' && this.state.addData.DiposedMTQuantity !== '') {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.addData.Remarks != null) {
                this.state.addData.Remarks = this.state.addData.Remarks.trim();
                this.setState({})
            }
            if (this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
                this.setState({})
            }
            if (this.state.addData.QuantityIHM == "") {
                this.state.addData.QuantityIHM = 0;
                this.setState({})
            }
            if (this.state.addData.Material === "0") {
                this.state.addData.Material = ""
            }
            if (this.state.addData.QuantityGPCB == '') {
                this.state.addData.QuantityGPCB = 0;
                this.setState({})
            }
            let formData = new FormData()
            formData.append("attachments", this.state.Docs.fdata)
            this.putdisdocinfo(this.state.addData, formData, this.state.addData.Id)
        }
    }
    putdisdocinfo = (data, formData, id) => {

        let apiUrl = API.DIS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (this.state.Docs.fdata != undefined) {
                        this.adduploadsocdocinfo(formData, id)
                    }
                    else {
                        this.props.navigate("/dispositionrecordsofhazardousmaterials")
                    }

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e.target.value;
        this.setState({});
    };
    renderProjectNames = (state, val) => {
        return state?.addData?.Material.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e;
        this.setState({});
    };

    
    adduploadsocdocinfo = (data, id) => {
        let apiUrl = API.DIS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/dispositionrecordsofhazardousmaterials")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100  mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"DIS" + "1"} className=' textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="DIS" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5">
                                    <h4>Edit Disposition Record Of Hazardous Materials</h4>
                                </div>
                            </div>


                        </>

                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {this.state.value === 1 ? <><td className="border-right" width="5%">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1} ></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </> : <></>
                                }
                                {this.state.value == 1 ? <></> : <>

                                    <td className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                    <td className="border-right text-center">
                                        <span className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                    </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} onClick={this.EditCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                    </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} data-target="#deletepopup1" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span>
                                    </td>
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                    <td width="95%">
                                        {this.state.value == 1 ? <></> : <>
                                            <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                            <button className={`${classes.button} pl-3`} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            <button className={`${classes.button} pl-3`} data-target="#deletepopup1" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">Edit Disposition Record Of Hazardous Materials</h6>}
                        <div className="row">
                            <div >
                                <AppBar position="static" color="inherit" className={classes.root}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab label="Details" className=" px-1 ml-4" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(0)} />
                                        <Tab label="History log" className="" style={{ textTransform: "none", minWidth: '13px' }}{...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                                <TabPanel value={this.state.value} index={0}>
                                    <div>
                                        <div className={this.state.isMobile ? "row px-0 mt-n3" : "row px-2 mt-n3"}>
                                            <div className={`row  mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right m-0"}>Date&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.Error.DateError ?
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            id="type-date"
                                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                            type="date"
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                            classes={{ root: classes.helperText }}
                                                        /> :
                                                        <TextField
                                                            type="date"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            id="type-date"
                                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                            inputProps={{
                                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                              }}
                                                        />
                                                    }
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Material&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {/* <select className="form-control border-radius"
                                                        onChange={(e) => { this.handleInputChange(e, "Material") }}
                                                        value={this.state.addData.Material}
                                                    >
                                                        <option value={0}>Select Status</option>
                                                        {this.props.DIS_Material.length > 0 &&
                                                            this.props.DIS_Material.map((i) => {
                                                                return <option value={i.Name}>{i.Name}</option>;
                                                            })}
                                                    </select> */}

                                                    <div className=" autocomplete-wrappers">
                                    <Autocomplete
                                        contentEditable={true}
                                        value={this.state.addData.Material}
                                        inputProps={{
                                            placeholder: "Material",
                                        }}
                                        items={this.props.DIS_Material ?? []}
                                        getItemValue={(item) => item.Name}
                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                        renderMenu={(item) => (
                                            <div className="dropdowns d-block" >{item}</div>
                                        )}

                                        renderInput={(props) => {
                                            return (
                                                <input
                                                    className="form-control border-radius"
                                                    id="exampleFormControlInput1"
                                                    {...props}
                                                    fullWidth
                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                />
                                            );
                                        }}

                                        renderItem={(item, isHighlighted) => (
                                            <div
                                                className={`items 
                         ${isHighlighted ? "selected-items" : ""
                                                    }`}
                                            >
                                                {item.Name}
                                            </div>
                                        )}
                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                    />
                                    </div>
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Manifest No&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={this.state.addData.ManifestNo}
                                                        onChange={(e) => { this.handleInputChange(e, "ManifestNo") }}
                                                        type="number"
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Attachment&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        disabled
                                                        variant="outlined"
                                                        size="small"
                                                        placeholder="Browse File"
                                                        fullWidth
                                                        accept=".pdf"
                                                        onChange={(e) => this.UploadFile(e)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment className="mr-0">
                                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                        <AttachFileIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <input
                                                        hidden
                                                        accept=".pdf"
                                                        type="file"
                                                        ref={this.inputFile}
                                                        onChange={(e) => this.UploadFile(e)}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                    <div className="row px-1">
                                                        {this.state.Docs.FileName == undefined ? <></> :
                                                            <div className={`col-10 col-sm-6 col-lg-4 col-xl-3 align-items-center px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-6 " : "col-md-6"}`}>
                                                                <div className="row d-flex">
                                                                    <div className="pt-1 col-8">
                                                                        <div className="pt-2 overflow">{this.state.Docs.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(this.state.Docs.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                    </div>
                                                                    <div className="mt-2 pt-2 col-1">
                                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(this.state.Docs.FileName, this.state.Docs.AwsUniqueFileName, this.state.Docs.Id) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Quantity As Per IHM&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        placeholder="0.0"
                                                        value={this.state.addData.QuantityIHM}
                                                        onChange={(e) => { this.handleNumberChange(e, "QuantityIHM") }}
                                                        type="number"
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`,
                                                            maxLength: 10,
                                                            step: "1"
                                                        }}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end text-right"}>Quantity By GPCB (MT)&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        fullWidth
                                                        placeholder="0.0"
                                                        value={this.state.addData.QuantityGPCB}
                                                        onChange={(e) => { this.handleNumberChange(e, "QuantityGPCB") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`,
                                                            maxLength: 10,
                                                            step: "1"
                                                        }}
                                                    />
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right m-0"}>Quantity (MT) Disposed&nbsp;:
                                                        <div className={`${classes.helperText}`}>
                                                            <div className="MuiFormHelperText-contained">*</div>
                                                        </div></label>                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                    {this.state.Error.DiposedMTQuantityError ?
                                                        <TextField
                                                            type="number"
                                                            variant="outlined"
                                                            size="small"
                                                            fullWidth
                                                            error
                                                            placeholder="0.0"
                                                            value={this.state.addData.DiposedMTQuantity}
                                                            onChange={(e) => { this.handleNumberChange(e, "DiposedMTQuantity") }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                                maxLength: 10,
                                                                step: "1"
                                                            }}
                                                            classes={{ root: classes.helperText }}
                                                        />
                                                        :
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            value={this.state.addData.DiposedMTQuantity}
                                                            onChange={(e) => { this.handleNumberChange(e, "DiposedMTQuantity") }}
                                                            fullWidth
                                                            placeholder="0.0"
                                                            type="number"
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                                maxLength: 10,
                                                                step: "1"


                                                            }}
                                                        />}
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Remarks&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={4}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={this.state.addData.Remarks}
                                                        onChange={(e) => { this.handleInputChange(e, "Remarks") }}

                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Remarks?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Remarks?.length}/500 Characters left</label>
                                                </div>
                                            </div>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? "pt-2" : "float-end"}>Comments&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                    <TextField
                                                        multiline
                                                        rows={8}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={this.state.addData.Comments}
                                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                        <div class="modal-dialog" role="document">
                                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                                <div class="modal-body pb-0">
                                                    <h1 className="text-center">
                                                        <img src={del}></img>
                                                    </h1>
                                                    <div className="text-center">
                                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                                </div>
                                                <div class="modal-footer border-top-0 m-auto">
                                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                                    <button type="button" id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel value={this.state.value} index={1}>
                                    <div className="row">
                                        <div className="mt-n3">
                                            <div className="col-sm-12 col-12 px-0">
                                                <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                    <table id="dataTable" className="table">
                                                        <thead>
                                                            <tr className="">
                                                                <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                                <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                                <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                                <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                            {this.props.historyLog && this.props.historyLog.map((i) => (
                                                                <tr>
                                                                    <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                        {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                    </td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                    <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItemID}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" onClick={() => { window.$("#cancelpopup").modal("hide") }} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        DIS_Material: state.MasterDataReducer.Lookup_data || [],
        errordispass: state.DispositionReducer.errordispass || [],
        shareddisfiles: state.DispositionReducer.shareddisfiles || [],
        geteditdis: state.DispositionReducer.geteditdis || [],
        shareddisdata: state.DispositionReducer.shareddisdata || [],
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
};


EditDROHM.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDROHM))
);

